<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.tripReimbursementStatus === 'N'
              ? 'primary'
              : row.tripReimbursementStatus === 'S'
              ? 'warning'
              : row.tripReimbursementStatus === 'Y'
              ? 'success'
              : row.tripReimbursementStatus === 'D' ||
                row.tripReimbursementStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_tripReimbursementStatus }}
        </el-tag>
      </template>
      <template v-slot:currencyAmount="{ row }">
        <span>{{
          row.v_currencyAmount +
            ' ' +
            (row.v_currencyUnit ? row.v_currencyUnit : '--')
        }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.tripReimbursementCode },
                  query: { tripReimbursementNo: row.tripReimbursementNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="
              row.tripReimbursementStatus === 'N' ||
                row.tripReimbursementStatus === 'R'
            "
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.tripReimbursementCode },
                  query: { tripReimbursementNo: row.tripReimbursementNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.Rejected') || '驳回'"
            placement="top"
            v-if="allow('R')"
            v-show="row.tripReimbursementStatus === 'Y'"
          >
            <i
              class="el-icon-refresh-left tool-btn"
              @click="rejected(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="
              row.tripReimbursementStatus === 'N' ||
                row.tripReimbursementStatus === 'R'
            "
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.tripReimbursementCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
            v-if="allow('T')"
          >
            <i
              class="el-icon-s-check tool-btn"
              @click="submitReview(row.tripReimbursementCode)"
              v-show="
                row.tripReimbursementStatus === 'N' ||
                  row.tripReimbursementStatus === 'R'
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'personal-myTravelReimbursement-detail',
        params: { ...params, pageType },
        query,
      })
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .userTripReimbursementDelApi({ tripReimbursementCode: code })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    rejected({ tripReimbursementCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_reject') || '是否驳回该审核请求？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .userTripReimbursementRejectedApi({ tripReimbursementCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.tips_rejected_successfully') || '驳回成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('INDEX.tips_reject_failed') || '驳回失败！'
            )
          })
      })
    },
    submitReview(val) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核?',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .userTripReimbursementAuditApi({
            tripReimbursementCode: val,
          })
          .then(() => {
            this.$api
              .userTripReimbursementOaApply({
                tripReimbursementCode: val,
                linkUrl: this.$joinURL(`/opview/myTravelReimbursement/${val}`, {
                  joinOrigin: true,
                  joinBasePath: false,
                }),
              })
              .then(() => {
                this.loadingClose()
                this.$message.success(
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功!'
                )
                this.$emit('reload')
              })
              .catch(() => {
                this.loadingClose()
              })
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
